import { useRouter } from 'next/router';
import React from 'react';
import Image from 'next/image';
import classes from './styles.module.scss';
import { generateBlogUrl } from 'utils/blogs.util';
import SKButton from 'components/UI/SKButton';
import Link from 'next/link';

const BlogCard = ({ blog }) => {
  const router = useRouter();

  const formatDate = blogDate => {
    const date = new Date(blogDate);
    return date.toLocaleDateString('en-us', {
      month: 'short',
      year: 'numeric'
    });
  };

  return (
    <div className={classes.blogCard}>
      <div className={classes.top}>
        <div className={classes.imageContainer}>
          <Image
            src={blog.data.image}
            alt={blog.data.imageAlt || blog.data.title}
            title={blog.data.imageTitle || blog.data.title}
            style={{
              objectFit: 'fill'
            }}
            width={450}
            height={200}
          />
        </div>
      </div>
      <div className={classes.middle}>
        <span className={classes.date}>{formatDate(blog.data.date)}</span>
        <div className={classes.title}>
          <Link
            className={classes.link}
            href={generateBlogUrl(blog.data)}
            aria-label={blog.data.customTitle || blog.data.title}
          >
            {blog.data.customTitle || blog.data.title}
          </Link>
        </div>
        <div className={classes.description}>{blog.data.excerpt}</div>
      </div>
      <div className={classes.bottom}>
        <Link href={generateBlogUrl(blog.data)}>Read More</Link>
      </div>
    </div>
  );
};

export default BlogCard;
